import Vue from 'vue'
import {
	Tool
} from "./Tool.js";
import {
	Toast
} from 'vant'
Vue.use(Toast)

import JsBridge from "./JsBridge"

var tool = null

function getCurrentTools() {
	if (!tool) {
		tool = Tool.getTools()
	}
	if (!tool) {
		return true
	}
	return false
}

export function closeCurrentPage(status = 1) {
	if (getDeviceTypeName() === 'Android') {
		window.WebViewJavascriptBridge.onCloseCurrentPage(status)
	} else if (getDeviceTypeName() === 'iOS') {
		JsBridge.callHandler(
			'onCloseCurrentPage', {
			'status': status,
		},
			function (responseData) {
				//todo设置metaInfo 调用getAppToken
				console.log('-WebViewJavascriptBridge-closeCurrentPage', responseData)
			}
		)
	} else if (getDeviceTypeName() === 'Harmony') {
		console.log('harmonyEsign-onCloseCurrentPage')
		harmonyEsign.onCloseCurrentPage(status)
	}
}

export function downDMToSBox(url, fileName, postBody, headers) {
	return new Promise((resolve, reject) => {
		if (getDeviceTypeName() === 'Android') {
			JsBridge.callHandler(
				'downWithSkipSecureToSBOX', {
				'url': url,
				'fileName': fileName,
				'postBody': JSON.stringify(postBody),
				'headers': headers,
			},
				function (responseData) {
					//todo设置metaInfo 调用getAppToken
					console.log('-WebViewJavascriptBridge-downWithDMToSBOX', responseData)
					let result = JSON.parse(responseData)
					//todo获取结果，判断是否成功，调用返回
					resolve(result)
				}
			)
		} else if (getDeviceTypeName() === 'iOS') {
			JsBridge.callHandler(
				'downWithSkipSecureToSBOX', {
				'url': url,
				'fileName': fileName,
				'postBody': postBody,
				'headers': headers,
			},
				function (responseData) {
					//todo设置metaInfo 调用getAppToken
					console.log('-WebViewJavascriptBridge-downWithDMToSBOX', responseData)
					//let result = JSON.parse(responseData)
					//todo获取结果，判断是否成功，调用返回
					resolve(responseData)
				}
			)
		} else if (getDeviceTypeName() === 'Harmony') {
			harmonyEsign.downWithSkipSecureToSBOX(url, postBody, headers, fileName).then(res => {
				if (res) {
					resolve({ flag: true, message: res })
				} else {
					resolve({ flag: false })
				}
			})
		} else {
			reject(new Error('Unsupported platform'))
		}
	})

}


export function downloadFile(url, fileName, inSbox, params, headers) {
	return new Promise((resolve, reject) => {
		if (getDeviceTypeName() === 'plusAndroid') {
			let downResult = plus.android.implements(
				"com.uniapp.pcitc.esign.MyDownFileResult", {
				"setResult": function (status, result) {
					console.log(
						'newDownloadFile-setResult-=',
						status, result)
					if (result) {
						data.filePath = result
						resolve1(data)
					} else {
						reject1('下载文件失败')
					}
				}
			})
				(url, fileName, that.appCode, JSON
					.stringify({
						fileId: data.fileId,
						enkey: ''
					}), downResult)
		} else if (getDeviceTypeName() === 'plusiOS') {

		} else if (getDeviceTypeName() === 'Android') {
			//todo重新写url
			JsBridge.callHandler(
				'downWithDownloadManager', {
				'url': url,
				'fileName': fileName,
				'inSBox': inSbox,
				'headers': headers
			},
				function (responseData) {
					//console.log('downloadFile-downWithDownloadManager-=',responseData)
					let result = JSON.parse(responseData)
					//todo获取结果，判断是否成功，调用返回
					resolve(result)
				}
			)
		} else if (getDeviceTypeName() === 'iOS') {
			//console.log('downloadFile')
			JsBridge.callHandler('downWithFileDownloader', {
				'url': url,
				'fileName': fileName,
				'inSBox': inSbox,
				'params': params,
				'headers': headers
			}, function (response) {
				console.log('downWithFileDownloader', response)
				console.log('downWithFileDownloader', response.flag)
				if (response.flag) {
					console.log('downWithFileDownloader', response.message)
				}
				resolve(response)
			})
		} else if (getDeviceTypeName() === 'Harmony') {
			harmonyEsign.downFileWithHttpPostToSanBox(that.appCode,
				url, file.resName, data.fileId, '')
				.then(res => {
					if (res) {
						data.filePath = res
						resolve1(data)
					} else {
						reject1('下载文件失败')
					}
				}).catch(err => {
					console.log('downFileToSanBox-err-=', err)
					reject1('下载文件失败')
				})
		}
	})
	// return new Promise((resolve1, reject1) => {
	// 	let url = window.location.origin +
	// 		'/seal/api/doc/file/fetch?token=' + that.token
	// 	let fileName = 'document_' + Date.now() + '.pdf'
	// 	switch (getDeviceType()) {
	// 		case 'android':
	// 			// case 'ios':
	// 			let downResult = plus.android.implements(
	// 				"com.uniapp.pcitc.esign.MyDownFileResult", {
	// 					"setResult": function(status, result) {
	// 						console.log(
	// 							'newDownloadFile-setResult-=',
	// 							status, ·)
	// 						if (result) {
	// 							data.filePath = result
	// 							resolve1(data)
	// 						} else {
	// 							reject1('下载文件失败')
	// 						}
	// 					}
	// 				})
	// 			testDownloadFile(url, fileName, that.appCode, JSON
	// 				.stringify({
	// 					fileId: data.fileId,
	// 					enkey: ''
	// 				}), downResult)
	// 			break
	// 		case 'harmony':
	// 			harmonyEsign.downFileWithHttpPostToSanBox(that.appCode,
	// 					url, file.resName, data.fileId, '')
	// 				.then(res => {
	// 					if (res) {
	// 						data.filePath = res
	// 						resolve1(data)
	// 					} else {
	// 						reject1('下载文件失败')
	// 					}
	// 				}).catch(err => {
	// 					console.log('downFileToSanBox-err-=', err)
	// 					reject1('下载文件失败')
	// 				})
	// 			break;
	// 	}
	// })
}


export function startWhDjSignOrSeal(aFileName, signetList) {
	if (getDeviceTypeName() === 'Android') {
		window.WebViewJavascriptBridge.startWhDjSignOrSeal(aFileName, JSON.stringify(signetList))
	} else if (getDeviceTypeName() === 'iOS') {
		JsBridge.callHandler(
			'startWhDjSignOrSeal', {
			aFileName: aFileName,
			signetList: signetList
		},
			function (responseData) {
				console.log('-WebViewJavascriptBridge-startWhDjSignOrSeal', responseData)
			}
		)
	} else if (getDeviceTypeName() === 'Harmony') {

	}
}


export function startDianjuQuickSign(aFileName, infos, positions) {
	if (getDeviceTypeName() === 'plusAndroid') {
		if (getCurrentTools()) {
			return
		}
		tool.startDijuQuickSign(plus.android.runtimeMainActivity(), aFileName, infos, positions)
	} else if (getDeviceName() === 'android') {
		window.WebViewJavascriptBridge.startDijuQuickSign(infos, itemInfos)
	} else if (getDeviceName() === 'harmony') {
		harmonyEsign.onToQuickSign(infos, itemInfos)
	} else if (getDeviceName() === 'ios') {

	}
}

//1竖屏 2横屏
export function harmonyScreenSwitch(flag) {
	if (getDeviceTypeName() === 'Harmony') {
		return harmonyEsign.screenSwitch(flag)
	}
}



export function setScreenLandscape() {
	if (getDeviceTypeName() === 'Harmony') {
		harmonyEsign.screenSwitch('2')
	} else if (getDeviceTypeName() === 'Android') {
		window.WebViewJavascriptBridge.setLandscape()
	} else if (getDeviceTypeName() === 'iOS') {
		JsBridge.callHandler('setLandscape', {
			'': ''
		}, function (response) {

		})
	}
}

export function setScreenPortrait() {
	if (getDeviceTypeName() === 'Harmony') {
		harmonyEsign.screenSwitch('1')
	} else if (getDeviceTypeName() === 'Android') {
		window.WebViewJavascriptBridge.setPortrait()
	} else if (getDeviceTypeName() === 'iOS') {
		JsBridge.callHandler('setPortrait', {
			'': ''
		}, function (response) {

		})
	}
}


export function startScan() {
	if (getDeviceTypeName() === 'Harmony') {
		harmonyEsign.startScan()
	} else if (getDeviceTypeName() === 'Android') {
		window.WebViewJavascriptBridge.startScan()
	} else if (getDeviceTypeName() === 'iOS') {
		JsBridge.callHandler('startScan', {
			'flag': 'startScan'
		}, function (response) {
			console.log('startScan', response)
		})
	}

}

export function harmonyTakePhoto() {
	if (getDeviceTypeName() === 'Harmony') {
		return harmonyEsign.takePhoto()
	}
}

export function harmonySelectImage() {
	if (getDeviceTypeName() === 'Harmony') {
		return harmonyEsign.selectImage()
	}
}

export function isHarmony() {
	return getDeviceTypeName() === 'Harmony'
}

export function takePhoto() {
	switch (getDeviceName()) {
		case 'android':
			window.WebViewJavascriptBridge.startTakePhoto()
			break;
		case 'ios':
			JsBridge.callHandler('startTakePhoto', {
				'flag': 'startTakePhoto'
			}, function (response) {
				console.log('startTakePhoto', response)
			})
			break;
		case 'harmony':
			harmonyEsign.takePhoto()
			break;
	}
}


export function selectImage() {
	switch (getDeviceName()) {
		case 'android':
			window.WebViewJavascriptBridge.startSelectGallery()
			break;
		case 'ios':
			JsBridge.callHandler('startSelectGallery', {
				'flag': 'startSelectGallery'
			}, function (response) {
				console.log('startSelectGallery', response)
			})
			break;
		case 'harmony':
			harmonyEsign.selectImage()
			break;
	}
}


export function compressImage(path) {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			if (getCurrentTools()) {
				return
			}
			return tool.compressImage(path)
			break;
		case 'plusiOS':
			if (getCurrentTools()) {
				return
			}
			return tool.compressImage(path)
			break;
		case 'Harmony':

			break;
		case 'Android':
			window.WebViewJavascriptBridge.compressImage(path)
			break;
		case 'iOS':
			window.WebViewJavascriptBridge.compressImage(path)
			break;
		default:

			break;
	}
}

//
export function saveFileToDevice(fileUrl, fileName) {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			if (getCurrentTools()) {
				return
			}
			tool.saveFileToDevice(plus.android.runtimeMainActivity(), fileUrl, fileName)
			break;
		case 'plusiOS':
			if (getCurrentTools()) {
				return
			}
			tool.saveFileToDevice(fileUrl, fileName)
			break;
		case 'Harmony':

			break;
		case 'Android':
			window.WebViewJavascriptBridge.saveFileToDevice(fileUrl, fileName)
			break;
		case 'iOS':
			window.WebViewJavascriptBridge.saveFileToDevice(fileUrl, fileName)
			break;
		default:

			break;
	}
}

//
export function fromateDownloadPath(fileName) {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			break;
		case 'plusiOS':
			break;
		case 'Harmony':

			break;
		case 'Android':
			break;
		case 'iOS':
			fileName = 'Pandora/' + fileName
			break;
		default:

			break;
	}
	return fileName
}

//
export function saveFileToDownloads(sourceFileName, fileName) {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			if (getCurrentTools()) {
				return
			}
			return tool.saveFileToDownloads(plus.android.runtimeMainActivity(), sourceFileName, fileName)
			break;
		case 'plusiOS':
			if (getCurrentTools()) {
				return
			}
			return tool.saveFileToDownloads(sourceFileName, fileName)
			break;
		case 'Harmony':

			break;
		case 'Android':
			return window.WebViewJavascriptBridge.saveFileToDownloads(sourceFileName, fileName)
			break;
		case 'iOS':
			return window.WebViewJavascriptBridge.saveFileToDownloads(sourceFileName, fileName)
			break;
		default:

			break;
	}
}



//
export function openFile(path, type) {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			if (getCurrentTools()) {
				return
			}
			tool.openFile(plus.android.runtimeMainActivity(), path, type)
			break;
		case 'plusiOS':
			break;
		case 'Harmony':

			break;
		case 'Android':
			window.WebViewJavascriptBridge.openFile(path, type)
			break;
		case 'iOS':
			JsBridge.callHandler('openFile', {
				'filePath': path,
				'fileType': type
			}, function (response) {
				console.log('openFile', response)
			})
			break;
		default:

			break;
	}
}


export function deleteInternalFile(apkPath) {
	if (getDeviceTypeName() === 'plusAndroid') {
		if (getCurrentTools()) {
			return
		}
		return tool.deleteInternalFile(plus.android.runtimeMainActivity(), apkPath)
	}
	return 0
}

export function updateAndroidApk(apkPath) {
	if (getDeviceTypeName() === 'plusAndroid') {
		if (getCurrentTools()) {
			return
		}
		return tool.updateAndroidApk(plus.android.runtimeMainActivity(), apkPath)
	}
	return 0
}

//
export function getAppVersion() {
	let version = '1.0'
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			if (getCurrentTools()) {
				return
			}
			version = tool.getAppVersionName(plus.android.runtimeMainActivity())
			break;
		case 'plusiOS':
			if (getCurrentTools()) {
				return
			}
			version = tool.getAppVersionCode()
			break;
		case 'Harmony':

			break;
		case 'Android':
			version = window.WebViewJavascriptBridge.getAppVersionName()
			break;
		case 'iOS':

			break;
	}
	return version
}


//   INSERT INTO csp.app_version ("id","version","url","app_name","device_type") VALUES
// 	 (1,'1.0','https://xxx.com/xxx.apk','安卓','android');
//   INSERT INTO csp.app_version ("id","version","url","app_name","device_type") VALUES
// 	 (2,'1.0','','鸿蒙','harmonyos');
// 	 INSERT INTO csp.app_version ("id","version","url","app_name","device_type") VALUES
// 	 (3,'1.0','','苹果','ios');
//
export function getDeviceType() {
	let deviceType = ''
	if (Tool.checkIsHarmonyOS()) {
		deviceType = 'harmony'
	} else if (Tool.checkIsAndroidDevice()) {
		deviceType = 'android'
	} else if (Tool.checkIsAppleDevice()) {
		deviceType = 'ios'
	}
	return deviceType
}

//返回各种类型设备
export function getDeviceTypeName() {
	if (window.plus) {
		if (plus.os.name === 'Android') {
			return 'plusAndroid'
		} else if (plus.os.name === 'iOS') {
			return 'plusiOS'
		} else {
			return 'plusDevice'
		}
	} else {
		if (Tool.checkIsAndroidDevice()) {
			return 'Android'
		} else if (Tool.checkIsAppleDevice()) {
			return 'iOS'
		} else if (Tool.checkIsHarmonyOS()) {
			return 'Harmony'
		} else {
			return 'noDevice'
		}
	}
}


//
export function saveCorpQrCode(corpId, codeurl) {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			if (getCurrentTools()) {
				return
			}
			tool.saveCorpQrCode(plus.android.runtimeMainActivity(), corpId, codeurl)
			break;
		case 'plusiOS':
			if (getCurrentTools()) {
				return
			}
			tool.saveCorpQrCode(corpId, codeurl)
			break;
		case 'Harmony':

			break;
		case 'Android':

			break;
		case 'iOS':

			break;
		default:

			break;
	}
}

//
export function openCorpQrCode(corpId, codeurl) {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			if (getCurrentTools()) {
				return
			}
			tool.openCorpQrCode(plus.android.runtimeMainActivity(), corpId)
			break;
		case 'plusiOS':
			if (getCurrentTools()) {
				return
			}
			tool.openCorpQrCode(corpId, codeurl)
			break;
		case 'Harmony':

			break;
		case 'Android':

			break;
		case 'iOS':

			break;
		default:

			break;
	}
}